import React from 'react';
import { PictureProps } from '../../../types/components';

export default function Picture({
  image,
  classes,
  pictureClasses,
  loading,
}: PictureProps) {
  const {
    alt,
    transforms,
    defaultTransform,
    url,
  } = image;

  const media = {
    all : '',
    xs : '(max-width: 575px)',
    'sm-min' : '(min-width: 576px)',
    sm : '(max-width: 991px)',
    'md-min' : '(min-width: 992px)',
    md : '(max-width: 1279px)',
    'lg-min' : '(min-width: 1280px)',
    lg : '(max-width: 1599px)',
    'xl-min': '(min-width: 1600px)',
    xl : '(max-width: 1749px)',
    xxl : '(min-width: 1750px)',
  };

  return (
    <picture className={pictureClasses}>
      {Object.keys(media).map((key) => {
        if (key !== 'all' && transforms && transforms[key]) {
          return (
            <source
              key={key}
              media={media[key as keyof typeof media]}
              srcSet={transforms[key]?.url}
            />
          );
        }
        return null
      })}
      <img
        src={transforms ? transforms[defaultTransform]?.url : url}
        alt={alt}
        loading={loading}
        width={transforms ? transforms[defaultTransform]?.width : undefined}
        height={transforms ? transforms[defaultTransform]?.height : undefined}
        className={classes}
      />
    </picture>
  );
}
